<template>
    <div>
        <!--选择图片-->
        <div style="padding: 10px">
            <el-image :src="imageUrl"></el-image>
            <input type="file" accept="image/*" ref="inputFile" style="display: none;" @change="showCheckImg"/>
        </div>
        <el-button v-show="visibleState" plain style="margin-left: 10px;" @click="openCheckFile">选择图片</el-button>
    </div>
</template>

<script>
    export default {
        name: "CheckImageFile",
        props: {
            //如果是修改则不让显示选择图片
            visibleState: {
                type: Boolean,
                required: false,
                default: true

            }
        },
        data() {
            return {
                imageUrl: '../img/nullFile.png',
                backgroundColor: "#000000"
            }
        },
        methods: {
            openCheckFile() {
                this.$refs.inputFile.dispatchEvent(new MouseEvent('click'));
            },
            showCheckImg() {
                let self = this;
                let file = this.$refs.inputFile.files[0];
                let render = new FileReader();
                render.readAsDataURL(file);
                render.onload = function (event) {
                    self.imageUrl = event.target.result;
                }
            },
            //给父组件返回选中的文件
            returnImageFile() {
                return this.$refs.inputFile.files[0];
            },
            //恢复默认显示图片 以及清除inputFile
            clearImageInput() {
                this.imageUrl = '../img/nullFile.png';
                this.$refs.inputFile.value = "";
                this.backgroundColor = "#000000"
            },
        },
        mounted() {
            let url = sessionStorage.getItem("imageUrl");
            if(url!=null){
                this.imageUrl=url;
            }
        }
    }
</script>

<style scoped>

</style>
